import React from 'react';
import PropTypes from 'prop-types';
import AutoCompleteData from 'components/list/Filters/types/autocomplete/AutoCompleteData';
import AutoCompleteField from 'components/list/Filters/types/autocomplete/AutoCompleteField';
import { Field } from 'redux-form';

class RenderProviderInputField extends React.Component {
    render() {
        const {
            input,
            label,
            minLength,
            optionValue,
            reference,
            searchBy,
            searchParams,
        } = this.props;

        return (
            <AutoCompleteData
                input={ input }
                minLength={ minLength }
                reference={ reference }
                searchBy={ searchBy }
                searchParams={ searchParams }
            >
                <Field
                    component={ AutoCompleteField }
                    floatingLabelFixed={ false }
                    fullWidth={ true }
                    input={ input }
                    label={ label ? label : null }
                    name={ input.name }
                    optionText={ searchBy }
                    optionValue={ optionValue }
                />
            </AutoCompleteData>
        );
    }
}

RenderProviderInputField.defaultProps = {
    minLength: 3,
    optionValue: 'id',
    searchParams: {},
};

RenderProviderInputField.propTypes = {
    input: PropTypes.shape({
        name: PropTypes.string.isRequired,
        onBlur: PropTypes.func,
        onChange: PropTypes.func,
        onDragStart: PropTypes.func,
        value: PropTypes.value,
    }),
    label: PropTypes.string,
    minLength: PropTypes.number,
    optionValue: PropTypes.string,
    reference: PropTypes.string.isRequired,
    searchBy: PropTypes.string.isRequired,
    searchParams: PropTypes.object,
};

export default RenderProviderInputField;



// WEBPACK FOOTER //
// ./src/components/form/InputFields/AutoCompleteField/RenderProviderInputField.js